import { Flex, Text } from '@radix-ui/themes';
import { ErrorBoundary } from 'components/common/error-boundary';
import useVisionRemoteStore from 'components/sections/admin-portal/machines/editor/remote-vision-calibration.tab/store/useVisionRemoteStore';
import { VISION_REMOTE_STAGES } from 'enums/calibration';
import { RADIX } from 'lib_ts/enums/radix-ui';

// * note - we do not show a header for the Overview stage, so no need to adjust for 0 index when rendering `Step ${index} of 4`
export const RemoteVisionCalibrationStageHeader = () => {
  const stage = useVisionRemoteStore((s) => s.stage);

  const stageDetails = VISION_REMOTE_STAGES[stage];
  const numStages = Object.keys(VISION_REMOTE_STAGES).length - 1; // exclude Overview

  return (
    <ErrorBoundary identifier="RemoteVisionCalibrationStageHeader">
      <Flex direction="column" gap={RADIX.FLEX.GAP.XS}>
        <Text
          size="1"
          color={RADIX.COLOR.SECONDARY}
        >{`Step ${stageDetails.index} of ${numStages}`}</Text>
        <Text
          size="3"
          style={{
            color: RADIX.COLOR.SAFE_TEXT,
          }}
          weight="medium"
        >
          {stageDetails.title}
        </Text>
        <Text size="2" color={RADIX.COLOR.SECONDARY}>
          {stageDetails.description}
        </Text>
      </Flex>
    </ErrorBoundary>
  );
};
